import { extendTheme } from '@chakra-ui/react';
import { colors, elevation } from 'constants/constants';

export const theme = extendTheme({
  fonts: {
    heading: `'Chakra Petch',-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Chakra Petch',-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  },
  styles: {
    global: {
      'h1': {
        fontSize: 'clamp(2rem, 6vw, 2.7rem)',
        lineHeight: 'normal',
        marginBottom: '0.6em',
      },
      'h2': {
        fontSize: 'clamp(1.5rem, 5vw, 2rem)',
        lineHeight: 'normal',
        marginBottom: '0.6em',
      },
      'h3': {
        fontSize: 'clamp(1.3rem, 4vw, 1.75rem)',
        lineHeight: 'normal',
        marginBottom: '0.6em',
      },
      'h4': {
        fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
        lineHeight: 'normal',
        marginBottom: '0.6em',
      },
      'h5': {
        fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
        lineHeight: 'normal',
        marginBottom: '0.6em',
      },
      'h6': {
        fontSize: '1rem',
        lineHeight: 'normal',
        marginBottom: '0.6em',
      },
      '.umb-text-block h1, .umb-text-block h2, .umb-text-block h3, .umb-text-block h4, .umb-text-block h5, .umb-text-block h6, .umb-cta-block h1, .umb-cta-block h2, .umb-cta-block h3, .umb-cta-block h4, .umb-cta-block h5, .umb-cta-block h6':
        {
          marginBottom: '0.6em',
        },
      '.umb-text-block .chakra-heading, .umb-cta-block .chakra-heading': {
          marginBottom: '0.6em',
          fontWeight: 600,
      },
      '.umb-text-block p, .umb-cta-block p': {
        paddingBottom: '1em',
      },
      '.umb-text-block ol, .umb-text-block ul, .umb-cta-block ol, .umb-cta-block ul':
        {
          margin: '0 0 1em 1.5em',
          padding: 0,
        },
       
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 50,
      },
      variants: {
        primary: {
          bg: colors.primary[900],
          color: colors.white,
          fontWeight: 400,
          paddingX: 12,
          _hover: { bg: colors.black, textDecoration: 'none' },
        },
        darkSolid: {
          bg: colors.neutrals[900],
          color: colors.white,
        },
        solid: {
          bg: colors.system.error[900],
          color: colors.white,
          fontSize: '14px',
        },
        ml: {
          bg: colors.primary[900],
          color: colors.white,
          _hover: { bg: colors.black },
        },
        success: {
          bg: colors.system.success[900],
          color: colors.white,
        },
        outline: {
          color: colors.black,
          bg: colors.white,
          border: '1px solid black',
          borderColor: 'black',
        },
        inlineBtn: {
          bg: 'transparent',
          p: 0,
          h: 'auto',
          _hover: { bg: 'transparent' },
        },
        logout: {
          bg: colors.system.error[900],
          color: colors.white,
          _hover: { bg: colors.system.error[500] },
        },
        bookingBtn: {
          boxShadow: elevation['+40'],
          pos: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          right: '1em',
          width: '4em',
          height: '4em',
          borderRadius: '4em',
          bg: colors.system.success[900],
          color: 'white',
        },
        orange: {
          bg: colors.primary[900],
          color: 'white',
          border: 'none',
          _hover: { bg: colors.primary[800] },
        },
        black: {
          bg: colors.black,
          color: 'white',
          border: 'none',
          _hover: { bg: colors.black },
        },
        outlined: {
          bg: 'transparent',
          color: colors.black,
          border: `1.5px solid ${colors.black}`,
          _hover: { bg: colors.neutrals[50] },
        },
        white: {
          bg: colors.white,
          color: colors.black,
          border: 'none',
          _hover: {   border: `1.5px solid ${colors.black}`},
        },
      },
    },
    Container: {
      baseStyle: {
        maxW: '7xl',
      },
    },
    Heading: {
      baseStyle: {
        color: colors.neutrals[900],
        fontWeight: 600,
      },
      variants: {
        productCardHeading: {
          fontWeight: 'bold',
          fontSize: 'xl',
        },
        checkoutBorderHeading: {
          as: 'h2',
          borderBottom: '1px solid',
          borderColor: colors.secondary[500],
          pb: 3,
          mb: 3,
        },
        semiBold: {
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '24px',
          lineHeight: '29px',
          color: colors.secondary.darkGrey,
        },
        moneyLargeBold: {
          as: 'h2',
          fontStyle: 'Normal',
          fontWeight: 'bold',
          fontSize: '80px',
          lineHeight: '106px',
        },
      },
    },
    Text: {
      variants: {
        preamble: {
          fontSize: 20,
        },
        productCardPreamble: {
          color: colors.neutrals[300],
        },
        productCardMoney: {
          fontWeight: 'bold',
          fontSize: 'lg',
          color: colors.system.success[900],
        },
        checkoutFacilityName: {
          fontSize: 'xs',
        },
        checkoutProductName: {},
        checkoutProductSize: {
          fontSize: 'xl',
          fontWeight: '600',
          color: colors.secondary.darkGrey,
        },
        checkoutProductDescription: {},
        checkoutProductMoney: {
          fontWeight: '600',
          fontSize: 'xl',
          color: colors.system.success[900],
        },
      },
    },
    FormLabel: {
      variants: {
        reactSelectLabel: {
          pos: 'absolute',
          top: '1.25em',
          left: '40px',
          color: colors.secondary[700],
        },
      },
    },
    Tooltip: {
      baseStyle: {
        p: 2,
        borderRadius: '.5em',
      },
      variants: {
        reactSelectTooltip: {
          bg: colors.system.success[900],
          color: 'white',
        },
      },
    },
  },
});
